document.addEventListener("DOMContentLoaded", function() {
	
	var lazyPictures = [].slice.call(document.querySelectorAll("picture.lazy"));
	var ajaxPictures = [].slice.call(document.querySelectorAll('[data-load="ajaxlazy"]'));


	if ("IntersectionObserver" in window) {
		let lazyPictureObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(entry) {
				if (entry.isIntersecting) {
					
					let lazyPicture = entry.target;

					let nodesSources = lazyPicture.querySelectorAll('source');
					if(typeof nodesSources !== 'undefined') {
						nodesSources.forEach(function(lazySource) {
							lazySource.srcset = lazySource.dataset.srcset;
						});
					}

					let nodesImages = lazyPicture.querySelectorAll('img');
					if(typeof nodesImages !== 'undefined') {
						let lazyImage = nodesImages[0];
						lazyImage.src = lazyImage.dataset.src;
					}

					lazyPicture.classList.remove("lazy");
					lazyPicture.classList.add("loaded");
					lazyPictureObserver.unobserve(lazyPicture);
				}
			});
		});



		let ajaxPicturesObserver = new IntersectionObserver(function(entries, observer) {
			
			
			
			
		});


		lazyPictures.forEach(function(lazyPicture) {
			lazyPictureObserver.observe(lazyPicture);
		});
		
		ajaxPictures.forEach(function(ajaxPicture) {
			ajaxPicturesObserver.observe(ajaxPicture);
		});
		
	} else {
	  // Possibly fall back to a more compatible method here
	}
	
  
});